import AltRouteRoundedIcon from '@mui/icons-material/AltRouteRounded';
import AssessmentRoundedIcon from '@mui/icons-material/AssessmentRounded';
import ExploreRoundedIcon from '@mui/icons-material/ExploreRounded';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Inventory2RoundedIcon from '@mui/icons-material/Inventory2Rounded';
import ListAltRoundedIcon from '@mui/icons-material/ListAltRounded';
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded';
import PictureAsPdfRoundedIcon from '@mui/icons-material/PictureAsPdfRounded';
import { Button, Divider, Stack, Typography } from '@mui/material';
import { FC, memo } from 'react';

type Props = {
  printAllOperationDirectionsOnClick: () => void;
  printAllTruckDirectionsOnClick: () => void;
  printUnloadTruckDirectionsOnClick: () => void;
  printPickingListOnClick: () => void;
  printProductCourseListOnClick: () => void;
  printCourseDeliveryCountReportOnClick: () => void;
  printDeliveryByCourseReportOnClick: () => void;
  downloadPlanCsvPerPacketOnClick: () => void;
  downloadPlanCsvPerPlaceOnClick: () => void;
}

const SelectPrintPresenter: FC<Props> = memo((
  {
    printAllOperationDirectionsOnClick,
    printAllTruckDirectionsOnClick,
    printUnloadTruckDirectionsOnClick,
    printPickingListOnClick,
    printProductCourseListOnClick,
    printCourseDeliveryCountReportOnClick,
    printDeliveryByCourseReportOnClick,
    downloadPlanCsvPerPacketOnClick,
    downloadPlanCsvPerPlaceOnClick
  }
) => (
  <Stack p={2} spacing={1}>
    <Stack>
      <Typography>
        出力形式を選択してください
      </Typography>
    </Stack>
    <Stack divider={<Divider />} spacing={1}>
      <Stack>
        <Button
          onClick={printAllOperationDirectionsOnClick}
          startIcon={<ExploreRoundedIcon />}
          endIcon={<PictureAsPdfRoundedIcon />}
        >
          配送指示書
        </Button>
      </Stack>
      <Stack>
        <Button
          onClick={printPickingListOnClick}
          startIcon={<ListAltRoundedIcon />}
          endIcon={<PictureAsPdfRoundedIcon />}
        >
          ピッキングリスト
        </Button>
      </Stack>
      <Stack>
        <Button
          onClick={printProductCourseListOnClick}
          startIcon={<Inventory2RoundedIcon />}
          endIcon={<PictureAsPdfRoundedIcon />}
        >
          商品別コースリスト
        </Button>
        <Button
          onClick={printDeliveryByCourseReportOnClick}
          startIcon={<LocalShippingRoundedIcon />}
          endIcon={<PictureAsPdfRoundedIcon />}
        >
          納品先別コースリスト
        </Button>
        <Button
          onClick={printCourseDeliveryCountReportOnClick}
          startIcon={<AssessmentRoundedIcon />}
          endIcon={<PictureAsPdfRoundedIcon />}
        >
          コース別配送件数リスト
        </Button>
      </Stack>
      <Stack>
        <Button
          onClick={downloadPlanCsvPerPacketOnClick}
          startIcon={<AltRouteRoundedIcon />}
          endIcon={<FileDownloadIcon />}
        >
          配車CSVダウンロード（商品毎）
        </Button>
        <Button
          onClick={downloadPlanCsvPerPlaceOnClick}
          startIcon={<AltRouteRoundedIcon />}
          endIcon={<FileDownloadIcon />}
        >
          配車XLSXダウンロード（地点毎）
        </Button>
      </Stack>
    </Stack>
  </Stack>
  ));

export default SelectPrintPresenter;
